<template>
  <div
    id="app"
    ref="tvuImg"
    class="home"
    :class="{ mobile: !isPc, pc: isPc }">
    <div style="display:none">
      isPc:{{isPc}},isSuccess:{{isSuccess}},isConfig:{{isConfig}},checkedCookie:{{checkedCookie}},isShowMyID:{{isShowMyID}}
      <br/><br/>
      signIn:  isPc:true,isSuccess:false,isConfig:false,checkedCookie:true,isShowMyID:false
      <br/><br/>
      welco: isPc:true,isSuccess:true,isConfig:false,checkedCookie:true,isShowMyID:false
    </div>
    <div
      class="banner"
      v-if="isPc && !isSuccess && !isConfig && checkedCookie">
      <div
        class="bannerImg"
        :style="{
          'z-index': backgroungList.length,
          background: `url(${backgroungList[0]})`,
        }" />
    </div>
    <div
      class="content clearfix"
      v-if="isPc & !isSuccess && !isShowMyID && !isConfig && checkedCookie">
      <div class="fl tvuIcon">
        <img
          class="tvuImg"
          src="https://dl.tvunetworks.com/static/html/TVU_Logo.png"
          alt="" />
        <span class="serviceName">{{ serverName }}
          <span
            class="copyRight"
            v-if="serverName == 'TVU networks'">&reg;</span>
        </span>
        <div v-if="isShowAppStore">
          <a
            :href="appStoreUrl"
            target="_blank"
            rel="noopener noreferrer">
            <img
              src="@/assets/img/app store.svg"
              alt="" />
          </a>
          <a
            class="marginL12"
            :href="androidAppUrl"
            target="_blank"
            rel="noopener noreferrer">
            <img
              :src="androidImage"
              alt=""/>
          </a>
        </div>
      </div>
      <!-- signIn登录页 -->
      <div class="fr form">
        <router-view />
        <div class="langfooter">
          <span class="title">{{ $t("lang.changeLang") }}：</span>
          <el-dropdown
            class="langSelector cursor"
            trigger="click"
            @command="changeLang">
            <span class="el-dropdown-link">
              <img
                :src="lang.src"
                alt=""
                style="margin-right: 5px" />
              <span class="langText">{{ lang.label }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu
              class="lang"
              slot="dropdown">
              <el-dropdown-item
                v-for="item in options"
                :key="item.value"
                :command="item"><img
                                  :src="item.src"
                                  alt=""
                                  style="margin-right: 5px" />
                <span>{{ item.label }}
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- Welcome页面 -->
    <div
      class="success"
      v-if="isPc && isSuccess && !isShowMyID && !isConfig && checkedCookie">
      <router-view/>
    </div>
    <div
      class="success config"
      v-if="isPc && isConfig && !isSuccess && !isShowMyID && checkedCookie">
      <router-view />
    </div>
    <div
      class="success disney"
      v-if="isPc && !isSuccess && !isConfig && isShowMyID && checkedCookie">
      <div class="disneyContent">
        <div class="disneyIcon">
          <img
            class="disneyImg"
            src="https://dl.tvunetworks.com/static/html/TVU_Logo.png"
            alt="" />
          <span class="serviceName">{{ serverName }}
            <span
              class="copyRight"
              v-if="serverName == 'TVU networks'">&reg;</span>
          </span>
        </div>
        <div class="loginBtn cursor">
          <a :href="myIdUrl">Sign in with
            <span>Disney MyID</span>
          </a>
        </div>
      </div>
    </div>
    <div
      class="content clearfix"
      v-if="!isPc">
      <div class="tvuLogo">
        <!-- <i class="el-icon-back cursor" ></i> -->
        <img
          class="mobileLogo"
          src="https://dl.tvunetworks.com/static/html/TVU_Logo.png"
          alt="" />
        <span class="serviceName">{{ serverName }}</span>
      </div>
      <div class="form">
        <router-view />
      </div>
    </div>
    <!-- 集成cookie-setting组件 -->
    <!-- <cookie-settings></cookie-settings> -->
    <!-- 谷歌登录提示 -->
    <google-login-tip v-if='showGoogleTip'></google-login-tip>
    <GoogleTip></GoogleTip>
    <login-tip-sso></login-tip-sso>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus'
import fn1 from '@/assets/js/facebook.js'
import { getUrlParam } from '@/assets/js/utils'
// import googleLogin from '@/assets/js/googleLogin.js'
import GoogleTip from './components/GoogleTip'
import LoginTipSso from './components/LoginTipSSO'
export default {
  name: 'App',
  data () {
    return {
      backgroungList: [
        // require('@/assets/img/bg1.jpg'),
        require('@/assets/img/bg2.jpg'),
        require('@/assets/img/bg3.jpg'),
        require('@/assets/img/bg4.jpg'),
        require('@/assets/img/bg5.jpg'),
        require('@/assets/img/bg6.jpg'),
        require('@/assets/img/bg7.jpg'),
        require('@/assets/img/login1.jpg'),
        require('@/assets/img/login2.jpg'),
        require('@/assets/img/login3.jpg'),
        require('@/assets/img/login4.jpg'),
        require('@/assets/img/login5.jpg'),
        require('@/assets/img/login6.jpg')
      ],
      index: 0,
      timer: null,
      isPc: false,
      options: [
        {
          value: 'zh',
          label: '中文',
          src: require('@/assets/img/🇨🇳.png')
        },
        {
          value: 'en',
          label: 'English',
          src: require('@/assets/img/🇺🇸.png')
        }
      ],
      currentLang: 'en',
      flag: require('@/assets/img/🇺🇸.png'),
      lang: {},
      serverName: '',
      disneyImg: require('@/assets/img/disneyBackground.png'),
      myIdUrl: '',
      isShowAppStore: false,
      appStoreUrl: '',
      checkedCookie: false,
      showGoogleTip: false,
      googleVisible: false,
      isCheckSession: false,
      sessionAppend: false,
      androidImage: '',
      androidAppUrl: ''
    }
  },
  components: {
    GoogleTip,
    LoginTipSso
  },
  created () {
    // 从sso页面进入欢迎页面需要设置isShowConfig为false，否则欢迎页不显示
    if (getUrlParam('fromPage') === 'sso') {
      this.$store.commit('changeShowConfig', false)
    }
    Bus.$on('showGoogleTipEvent', () => {
      this.showGoogleTip = window.location.hash === '#/signIn'
    })
    if (location.host.includes('com')) {
      this.appStoreUrl =
        'https://apps.apple.com/us/app/tvu-cc/id1501478726'
      this.androidImage = require('@/assets/img/google-play.svg')
    } else {
      this.appStoreUrl =
        'https://apps.apple.com/cn/app/tvu-cc/id1501478726'
      this.androidImage = require('@/assets/img/android.svg')
    }
    this.getServiceName() // 获取serviceName
    this.initConfig()
    Bus.$on('jumpLoginPage', function () {
      // window.location.href = that.initData.initConfig.userGroupUrl;
      const hostPath =
        window.location.protocol +
        '//' +
        window.location.host +
        '/newuserservice'

      window.location.href = hostPath
    })
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', () => {
        sessionStorage.setItem(
          'store',
          JSON.stringify(this.$store.state)
        )
        window.location.reload()
      })
    }
    if (window.location.href.indexOf('/welcome') > -1) {
      // setTimeout(() => {
      this.$store.state.isSuccess = true
      // }, 1000)
    } else {
      this.$store.state.isSuccess = false
    }
    this.backgroungList = this.backgroungList.map((n, i, all) => {
      const j = i + Math.floor(Math.random() * (all.length - i))
      const v = all[j]

      all[j] = n
      return v
    })
    // this.$store.commit('changeIsShowMyID',true);
    this.isPCMethod() // 判断平台
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 设置默认语言
    this.currentLang =
      localStorage.getItem('lang') ||
      navigator.language ||
      navigator.userLanguage
    // 中国区默认显示中文
    // if (location.host.includes('cn')) {
    //   this.currentLang = 'zh'
    // }
    if (this.currentLang.indexOf('zh') > -1) {
      this.$i18n.locale = 'zh'
      this.lang = {
        value: 'zh',
        label: '中文',
        src: require('@/assets/img/🇨🇳.png')
      }
    } else {
      this.$i18n.locale = 'en'
      this.lang = {
        value: 'en',
        label: 'English',
        src: require('@/assets/img/🇺🇸.png')
      }
    }
  },
  computed: {
    isSuccess () {
      return this.$store.state.isSuccess
    },
    isShowMyID () {
      return this.$store.state.isShowMyID
    },
    isConfig () {
      return this.$store.state.isShowConfig
    }
  },
  deactivated () {
    window.removeEventListener('pageshow', this.beforeUnloadEvent, false)
  },
  methods: {
    googleSessionFlag () {
      let googleSessionFlag = ''
      let cookieArr = document.cookie.split(';')
      for (let v of cookieArr) {
        if (v.split('=')[0].toLowerCase().trim() === 'googlesessionflag') {
          googleSessionFlag = v.split('=')[1]
          break
        }
      }
      return googleSessionFlag === '1'
    },
    async getInfoJson () {
      // let cookieArr = document.cookie.split(';')
      // let cookieCode = ''
      // for (let v of cookieArr) {
      //   if (v.split('=')[0].toLowerCase().trim() === 'sid') {
      //     cookieCode = v.split('=')[1]
      //     break
      //   }
      // }
      let serviceName = getUrlParam('serviceName')
      // 先排断有没有谷歌登录显示，如果有直接跳到登录页面，再判断有没有sid
      if (this.googleSessionFlag() || window.location.href.indexOf('/configPage') > -1) {
        this.checkedCookie = true
        // 没有sid，则跳转到signIn页面，只有isSuccess为false才可以跳转
        this.$store.state.isSuccess = false
        return
      }
      await this.axios.get(localStorage.getItem('userserviceAuthUrl') + '/main/checkUserAuth', { params: { serviceName: serviceName } }).then(res => {
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          // 有效的sid
          this.$store.state.validSid = true
          localStorage.setItem('session', data.session)
          // 进入登录页面时先判断是否有cookie，如果有直接登录
          this.checkHasCookie(data.session)
        } else {
          this.clearCookie()
        }
      }).catch(() => {
        this.clearCookie()
      })
    },
    // 如果有cookie，但是cookie失效了，则把cookie清掉
    clearCookie () {
      const localUrl = window.location.hostname
      const str1 = localUrl.split('.')[1]
      const str2 = localUrl.split('.')[2]

      this.domainName = `.${str1}.${str2}`

      const exp = new Date()

      exp.setTime(exp.getTime() - 1)
      window.document.cookie = `SID=;path=/;domain=${this.domainName};expires=${exp.toGMTString()};`
      this.checkedCookie = true
      // 如果有sid，但是sid失效了，则跳转到signIn页面，只有isSuccess为false才可以跳转
      this.$store.state.isSuccess = false
      // 失效的sid
      this.$store.state.validSid = false
    },
    checkHasCookie (cookieCode) {
      localStorage.setItem('session', cookieCode)
      let directUrl = ''

      if (window.location.href.indexOf('/welcome') > -1) {
        this.$store.state.isSuccess = true
        this.checkedCookie = true
        return
      }
      if (!this.getUrlParam('url') || this.getUrlParam('url').includes('null')) {
        this.$store.state.isSuccess = true
        this.$router.push('/welcome').then(() => { // promise
          // 路由跳转成功之后，在去更改checkedCookie的状态，否则会先加载signIn组件，再跳转到welcome，有可能会导致signIn页面在getVcode的时候清空sid
          this.checkedCookie = true
        })
      } else {
        this.isCheckSession = localStorage.getItem('sessionAppendService').includes(getUrlParam('serviceName'))
        // 在sessionAppendService列表里的服务，url需要拼接上session，不在的不拼session
        if (this.sessionAppend) {
          directUrl = `${getUrlParam('url')}?session=${cookieCode}`
        } else {
          if (this.isCheckSession) {
            directUrl = `${getUrlParam('url')}?session=${cookieCode}`
          } else {
            directUrl = `${getUrlParam('url')}`
          }
        }
        window.location.href = directUrl
      }
    },
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    beforeUnloadEvent () {
      if (window.performance && window.performance.navigation.type == 1) {
        if (window.location.href != this.$store.state.href) {
          this.$store.state.href = window.location.href
        }
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      }
    },
    isPCMethod () {
      const userAgentInfo = navigator.userAgent
      const Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod'
      ]

      let flag = true

      for (let v = 0; v < Agents.length; v++) {
        if (
          userAgentInfo.indexOf(Agents[v]) > 0 ||
          (/Mac/.test(navigator.userAgent) &&
            navigator.maxTouchPoints > 0)
        ) {
          flag = false
          break
        }
      }
      const anywheres = ['tvuhitme', 'tvuanywhere', 'tvuccmobile']

      if (anywheres.indexOf(this.getUrlParam('type')) > -1) {
        flag = false
      }
      this.isPc = flag
      this.$store.commit('getIsPc', this.isPc)
    },
    getCookie (name) {
      const arr = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      )

      if (arr != null) {
        return unescape(arr[2])
      }
      return false
    },
    delCookie (name) {
      const exp = new Date()

      exp.setTime(exp.getTime() + -1 * 24 * 60 * 60 * 1000)
      document.cookie =
        name +
        '=' +
        this.getCookie(name) +
        ';path=/;domain=' +
        this.domainName +
        ';expires=' +
        exp.toGMTString() // "isChecked" + "=" + this.checked + ";path=/;domain="+this.domainName+";expires=" + exdate.toGMTString();
    },
    changeLang (lang) {
      ga('send', 'event', 'newUserService-home-changeLang', 'click')
      this.lang = lang
      this.currentLang = lang.value
      if (this.currentLang.indexOf('zh') > -1) {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
      // this.$i18n.locale = lang.value;
      window.localStorage.setItem('lang', lang.value)
    },
    getServiceName () {
      const href = window.location.href

      if (href.indexOf('?') == -1) {
        this.serverName = 'TVU networks'
        return
      }
      let val = []

      if (href.includes('type=')) {
        // 移动端传参'http://211.160.178.10:20088/newuserservice/#/signIn?type=tvuhitme&peerId=1234&deviceName=aaa&vertion=111&deviceType=r';
        val = decodeURIComponent(href).split('?')
        if (val[1].includes('type')) {
          let serverName = ''

          serverName = val[1].split('type=')[1].split('&')[0]
          if (serverName) {
            switch (serverName) {
              case 'tvuhitme':
                this.serverName = 'TVU HitMe'
                break
              case 'tvuanywhere':
                this.serverName = 'TVU Anywhere'
                break
              case 'plustvuanywhere':
                this.serverName = 'TVU Anywhere Plus'
                break
              case 'tvuccmobile':
                this.serverName = 'TVU CCMobile'
                break
              default:
                this.serverName = serverName
                break
            }
          }
        }
      } else {
        // web 传参https://newuserservice.tvunetworks.com/newuserservice/?url=https://cc.tvunetworks.com/tvuccl?taskid=3e3f0612-f79c-41f9-80a7-13601ccec8c4&serviceName=Command%20Center#/signIn
        val = decodeURIComponent(href).split('?')
        let params = ''

        if (val.length > 2) {
          params = val[1] + '?' + val[2]
        } else {
          params = val[1]
        }
        if (params.includes('serviceName')) {
          // val = params.split('url=')[1].split('#')[0].split('&serviceName=')
          this.serverName = this.getUrlParam('serviceName')
        } else {
          this.serverName = 'TVU networks'
        }
      }
    },
    initConfig () {
      this.axios.get('/userGroup/user-group/login/initConfig').then(async (res) => {
        if (res.data.errorCode == '0x0') {
          const urlObj = res.data.result.myIdUrl
          const host = window.location.hostname
          let result = res.data.result
          if (result.gtag && result.gtagServiceName && result.gtagServiceName.includes(this.serverName)) {
            this.initGtag(result.gtag)
          }
          localStorage.setItem('googleCode', result.googleCode)
          // 微软登录clientId
          localStorage.setItem('microsoftClientId', result.microsoftClientId)
          // 九宫格列表服务地址
          let urlStr = result.userserviceAuthUrl

          urlStr = urlStr && urlStr.includes('//') ? urlStr.split('://')[1] : urlStr
          if (urlStr) {
            localStorage.setItem('userserviceAuthUrl', window.location.protocol + '//' + urlStr)
          }
          localStorage.setItem('userserviceUrl', result.userservice)
          this.$store.state.httpsFlag = result.httpsFlag
          // check url
          if (window.location.protocol == 'http:' && result.httpsFlag) {
            const url = window.location.href.replace(/(http):/, 'https:')

            window.location.href = url
            this.$store.state.href = url
            sessionStorage.setItem('store', JSON.stringify(this.$store.state))
          }
          // // 判断服务的协议和usersevice是不是一致
          // // 获取服务协议
          // let serviceUrl = location.href.split('url=')[1]
          // serviceUrl = serviceUrl ? serviceUrl.split('//')[0] : ''
          // if (serviceUrl && location.protocol != serviceUrl) {
          //   this.clearCookie()
          // }
          // check一下是否有cookie，且cookie是否有效，若有效则直接登录，无效才显示页面
          localStorage.setItem('sessionAppendService', result.sessionAppendService)
          this.sessionAppend = result.sessionAppend
          await this.getInfoJson()
          // 第三方登陆数组
          const tempList = []

          result.socialLogin.forEach((item) => {
            item ? tempList.push(item) : ''
          })
          this.$store.commit('changeSocialLogin', tempList)
          // websocket地址
          this.$store.commit('setWebsocketUrl', result.ccWebsocket)
          result.socialLogin.indexOf('FaceBook') > -1 ? fn1() : ''
          if (result.appleServer != undefined) {
            result.appleServer.includes(this.serverName) ? (this.isShowAppStore = true) : (this.isShowAppStore = false)
          }
          if (urlObj && typeof urlObj === 'object') {
            for (const i in urlObj) {
              if (host == i) {
                this.$store.commit('changeIsShowMyID', true)
                this.$store.commit('changeMyIdUrl', urlObj[i])
                this.myIdUrl = urlObj[i]
                return
              }
            }
          }
          this.$store.commit('changeTagKeyList', result.tagKeys || [])
          this.$store.commit('changeSearchRegisterUrl', result.searchRegisterUrl)
          this.$store.commit('setServiceListUrl', result.serviceListUrl)
          this.$store.commit('setWechatAppId', result.wechatAppId)
          this.$store.commit('saveTagCookie', result.saveTagCookie || false)
          // if (result.socialLogin.includes('Google')) googleLogin(result.googleClientId)
          this.$store.state.googleClientId = result.googleClientId
          this.$store.state.googleRedirectUrl = result.googleRedirectUrl
          if (location.host.includes('com')) {
            this.androidAppUrl = 'https://play.google.com/store/apps/details?id=com.tvunetworks.tvucc'
          } else {
            // 从接口获取cc安卓app下载地址，在中国区服务名是"Command Center"或者"Command Center Beta"的才去请求
            if (this.isShowAppStore) this.getCCAndroidDownloadUrl()
          }
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch((err) => {
        this.$message({
          message: err,
          type: 'error',
          duration: 3000
        })
      })
    },
    getCCAndroidDownloadUrl () {
      this.axios.get('/login-service/login/getCCDownloadUrl').then((res) => {
        if (res.data.errorCode === '0x0') {
          this.androidAppUrl = res.data.result
        }
      })
    },
    initGtag (tag) {
      // Global site tag (gtag.js) - Google Analytics
      (function (h, o, t, j, a, r) {
        a = o.getElementsByTagName('head')[0]
        r = o.createElement('script')
        r.async = 1
        r.src = t + j
        a.appendChild(r)
      })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', tag)
      window.dataLayer = window.dataLayer || []

      function gtag () { dataLayer.push(arguments) }

      gtag('js', new Date())
      gtag('config', tag)
    },
    getUrlParam (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substr(1).match(reg) || window.location.hash.substr(window.location.hash.indexOf('?') + 1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    }
  }

}
</script>
<style lang="less" scope>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#pro_nav_icon_bg {
  top: 6px !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.banner {
  height: 100vh;
  width: 100vw;
  position: fixed;
  overflow: hidden;
  .bannerImg {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    background-size: cover !important;
  }
}

.el-dropdown-menu.lang {
  border: none;
  background: rgba(58, 58, 58, 1);
  border-radius: 6px;
  /deep/li.el-dropdown-menu__item span {
    color: rgba(241, 241, 241, 1);
  }
  .el-dropdown-menu__item:hover {
    background: rgba(73, 73, 73, 1);
    color: #fff;
  }

  .popper__arrow {
    display: none;
  }
}

.tvuImg {
  width: 42px;
  margin-right: 10px;
  margin-top: 5px;
}

.mobileLogo {
  width: 36px!important;
}

.disneyImg {
  width: 55px;
}
</style>
